import { atom } from 'jotai';

import { AppNotification } from '@/hooks/useNotifications.types';

export interface NotificationsState {
  notifications: AppNotification[];
  unreadNotifications: AppNotification[];
  readNotifications: AppNotification[];
  isLoading: boolean;
  initialized: boolean;
  showRead: boolean;
}

export const initialNotificationsState: NotificationsState = {
  notifications: [],
  showRead: false,
  unreadNotifications: [],
  readNotifications: [],
  isLoading: false,
  initialized: false,
};

export const notificationsAtom = atom<NotificationsState>(
  initialNotificationsState
);
